import me from "models/me";

export default function (nextState, replace, callback) {
    if (me.isSignedIn() && me.last_brand) {
        replace(`/brand/${me.last_brand}`);
    }
    callback();
}
